import Types from "./Types";

const INITIAL_STATE = {
  exams: [],
  examQuestions: [],
  studentExams: [],
  exam: {},
  isLoading: false,
  publishLoading: false,
  restrictLoading: false,
  enableLoading: false,
  count: "",
  manualExams: [],
  manualExamsMarks: [],
};

export default function superadminExams(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_EXAMS_SUCCESS: {
      return {
        ...state,
        exams: payload.data,
        count: payload.data.length,
      };
    }
    case Types.SUPERADMIN_GET_COURSE_EXAM_SUCCESS: {
      return {
        ...state,
        exams: payload.data,
        count: payload.data.length,
      };
    }
    case Types.GET_ALL_SUPERADMIN_EXAM_QUESTIONS_SUCCESS: {
      return {
        ...state,
        examQuestions: payload.data,
      };
    }

    case Types.GET_SUPERADMIN_EXAMS_SUPER_ADMIN_SUCCESS: {
      return {
        ...state,
        exams: payload.data,
        count: payload.data.length,
      };
    }
    case Types.GET_ADMIN_STUDENT_SUPERADMIN_EXAMS_SUCCESS: {
      return {
        ...state,
        studentExams: payload.data,
        count: payload.data.length,
      };
    }

    case Types.RESTRICT_SUPERADMIN_EXAM_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.ENABLE_SUPERADMIN_EXAM_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.GET_SUPERADMIN_EXAM_SUCCESS: {
      return {
        ...state,
        exam: payload,
      };
    }

    case Types.EDIT_SUPERADMIN_EXAM_SUCCESS: {
      let data = payload.data;
      const exams = state.exams;
      let idx = 0;
      exams.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      exams[idx] = data;
      return {
        ...state,
        exams: exams,
      };
    }

    // create
    case Types.CREATE_SUPERADMIN_EXAM_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.exams.slice();
      let index = state.exams.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        exams: newArray,
      };
    }
    case Types.CREATE_SUPERADMIN_EXAM_QUESTIONS_SUCCESS: {
      const data = payload.data.data;

      return {
        ...state,
      };
    }
    case Types.ADD_SUPERADMIN_EXAMS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_SUPERADMIN_EXAM_SUCCESS: {
      const newexams = state.exams.filter((item) => item.id !== payload);
      return {
        ...state,
        exams: newexams,
      };
    }

    case Types.PUBLISH_SUPERADMIN_EXAM_LOADING: {
      return {
        ...state,
        publishLoading: payload,
      };
    }
    case Types.RESTRICT_SUPERADMIN_EXAM_LOADING: {
      return {
        ...state,
        restrictLoading: payload,
      };
    }

    case Types.ENABLE_SUPERADMIN_EXAM_LOADING: {
      return {
        ...state,
        enableLoading: payload,
      };
    }

    case Types.PUBLISH_SUPERADMIN_EXAM_SUCCESS: {
      let id = payload.payload;
      let data = payload.result.data.data;
      const exams = state.exams;
      let idx = 0;
      exams.forEach((table, index) => {
        if (table.id === id) {
          idx = index;
          return;
        }
      });

      exams[idx].auto_publish_result = data?.auto_publish_result;
      return {
        ...state,
        exams: exams,
      };
    }
    case Types.EDIT_SUPERADMIN_EXAM_QUESTION_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.ADD_BULK_CORRECTION_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.GET_MANUAL_EXAMS_SUCCESS: {
      return {
        ...state,
        exams: payload.data,
      };
    }
    case Types.GET_MANUAL_EXAMS_MARKS_SUCCESS: {
      return {
        ...state,
        marks: payload.data,
      };
    }
    case Types.SET_MANUAL_EXAM_MARK_SUCCESS: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
}
